module.exports = __webpack_public_path__ + "static/media/42-5.77379678.mp3";